import { Tag } from 'antd';
import { type, typeOfEdo } from '../EdoAlertForm';

export const columns = [
  {
    title: 'Заголовок',
    dataIndex: 'title',
    key: 'title',
  },
  {
    title: 'Заголовок (Каз)',
    dataIndex: 'title_kz',
    key: 'title_kz',
  },
  {
    title: 'Описание',
    dataIndex: 'description',
    key: 'description',
  },
  {
    title: 'Описание (Каз)',
    dataIndex: 'description_kz',
    key: 'description_kz',
  },
  {
    title: 'Тип',
    dataIndex: 'alert_type',
    key: 'alert_type',
    render: (i) =>
      type.find((val) => val.value === i)?.text ?? 'Неизвестный тип',
    filters: type,
  },
  {
    title: 'Разрешить подпись',
    dataIndex: 'allow_sign',
    key: 'allow_sign',
    render: (value) => (value ? 'Да' : 'Нет'),
    filters: [
      { text: 'Да', value: true },
      { text: 'Нет', value: false },
    ],
  },
  {
    title: 'Страницы сайта',
    dataIndex: 'page_type',
    key: 'page_type',
    filters: typeOfEdo,
    onFilter: (value, record) => record.page_type.indexOf(value) === 0,
    render: (value) => (
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
        {value?.map((i) => (
          <Tag key={i}>{typeOfEdo.find((val) => val.value === i)?.text}</Tag>
        )) ?? '---'}
      </div>
    ),
  },
  {
    title: 'Для всех сайтов',
    dataIndex: 'is_for_all',
    filters: [
      { text: 'Да', value: true },
      { text: 'Нет', value: false },
    ],
    key: 'is_for_all',
    render: (value) => (value ? 'Да' : 'Нет'),
  },
];
